import { Nullable } from "@tager/admin-services";

import { TermCreationPayload, TermUpdatePayload } from "@/services/requests";
import { TermType } from "@/typings/model";

export type FormValues = {
  term: string;
  value: string;
};

export function convertTermToFormValues(term: Nullable<TermType>): FormValues {
  if (!term) {
    return {
      term: "",
      value: "",
    };
  }
  return {
    term: term.term ?? "",
    value: term.value ?? "",
  };
}

export function convertFormValuesToTermCreationPayload(
  values: FormValues
): TermCreationPayload {
  return {
    term: values.term ?? "",
    value: values.value ?? "",
  };
}

export function convertFormValuesToTermUpdatePayload(
  values: FormValues
): TermUpdatePayload {
  return {
    term: values.term,
    value: values.value,
  };
}
